<template>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-12">
                <div class="card">

                    <!-- Card body -->
                    <div class="card-body">
                        <vue-form :state="formstate" @submit.prevent="create()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label class="form-control-label" for="nombres">Nombre*</label>
                                            <input type="text" class="form-control" id="nombres" v-model="model.nombre" name="nombres" placeholder="Escribe tu nombre" required>
                                            <field-messages name="nombres" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El nombre es requerido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label class="form-control-label" for="apellidos">Apellidos*</label>
                                            <input type="text" class="form-control" name="apellidos" id="apellidos" v-model="model.apellidos" placeholder="Apellidos" required>
                                            <field-messages name="apellidos" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">Los apellidos son requeridos</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label class="form-control-label" for="email">Correo electrónico*</label>
                                            <input class="form-control" id="email" name="email" v-model="model.email" placeholder="Dirección de correo válida" type="email" required >
                                            <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El correo electrónico es requerido</div>
                                                <div slot="email">El correo electrónico no es válido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
									<button type="submit" class="btn btn-primary " >Guardar</button>
                            </div>
                        </vue-form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
	import VueForm from "vue-form"
	import options from "../../validations/validations.js";

    export default {
    name: 'AdReference',
    components: {
    },
    data() {
        return {
            formstate: {},
            model: {
                nombre: '',
                apellidos: '',
                email: ''
            },            
        }
    },
    methods: {
        async create(){
            this.openLoading()
            await axios.post(`${apiKS}api/gca/referrals`, this.model, { headers })
                .then( response => {
                    Swal.close()
                    this.showMessage('Exito', response.data.message, 'success')
                    this.$emit('eventname') 
            } )
            .catch( error => {
                this.catchError(error)
            } )
        }
    },

    async mounted() {

    },
    watch: {
        
    }
}
</script>
